import { createFileRoute } from "@tanstack/react-router";
import { DatacentrePage, datacentreHead } from "@/pages/DatacentrePage";

export const Route = createFileRoute("/de/branchen/rechenzentren")({
  head: () => datacentreHead("de"),
  component: () => <DatacentrePage locale="de" />,
});
